export const environment = {
  production: false,
  appVersion: 'v726demo1',
  url: 'https://booktutti-staging.web.app',
  apiUrl: 'https://bookings-api-eat6v6w6ua-nw.a.run.app',
  apiUrlEmail: 'https://email-api-eat6v6w6ua-nw.a.run.app', // we will merge apiUrl and apiUrlEmail soon
  apiVersion: 'v1',
  auth0: {
    domain: "booktutti.eu.auth0.com",
    clientId: "7KpYCxuOcDsihaek89coh1j1dDF1WDa9",
    audience: "https://api.booktutti.com"
  },
  firebase: {
    projectId: 'tutti-crm-staging',
    appId: '1:325137905502:web:f56a0df5d4b03d9f3b01cf',
    storageBucket: 'tutti-crm-staging.appspot.com',
    apiKey: 'AIzaSyBQ6EWFXS9gh4PpSGCJBll1WIBjgc6TPuo',
    authDomain: 'tutti-crm-staging.firebaseapp.com',
    messagingSenderId: '325137905502',
  },
  sendGrid: {
    url: 'https://api.sendgrid.com/v3',
    key: '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',
  },
  mixpanel: {
    token: 'e42edc179960c7a943de6b1936c44b0b',
    config: {
      debug: true
    }
  },
  sentry: {
    dsn: 'https://0423755cb252ddf2f60833f70295d0ea@o1333678.ingest.us.sentry.io/4507526425280512',
    replaysSessionSampleRate: 0.1,
  },
  timeZone: 'Europe/London'
};
